// extracted by mini-css-extract-plugin
module.exports = {"container":"ChatbotButton_container__IaQv9","open":"ChatbotButton_open__WLQSr","button":"ChatbotButton_button__6_EMI","app":"ChatbotButton_app__aO93y"};